import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './fonts/SilversPersonalUseRegular-ZV22x.ttf'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<body>
    <App />
    {/* <footer>
      &copy; 2023 monk media
    </footer> */}
</body>
  </React.StrictMode>
);

